<!--
  设计原则是，一些敏感数据必须重新从数据中读取最新数据，比如一些事务性的数据，积分之类的。
-->
<template>
    <my-dialog ref="dialog" title="我的账户信息">
        <div align="center">
            <template v-if="!noSignalVisible">
                <div v-if="loading"><loading :text="null"></loading></div>
                <div v-else>
                    <el-card shadow="hover">
                        <!-- gutter 是设置栅格之间的间隔为 30 像素 -->
                        <el-row :gutter="20" style="height:40px">
                            <el-col :span="8" align="right"><icon-text icon-class="el-icon-picture-outline-round" text="头像:" :style-object="{height: '36px', lineHeight: '36px'}" /></el-col>
                            <el-col :span="16" align="left" style="display:inline-flex;">
                                <loading v-if="repaintAvatar" :text="null"></loading>
                                <avatar v-else :hash="username" :isDefaultRotate="false" :size="36"></avatar>
                                <div style="height:36px;line-height:36px;font-size:11px">（系统生成，暂不可修改）</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="height:40px;margin-top:10px">
                            <el-col :span="8" align="right"><icon-text icon-class="el-icon-user" text="用户名:" :style-object="{height: '36px', lineHeight: '36px'}" /></el-col>
                            <el-col :span="16" align="left">
                                <div class="username">
                                    <div v-show="!isShowUsernameInputEle">{{username}}</div>
                                    <el-input ref="username"
                                              size="small"
                                              @input="usernameInputChange"
                                              @change="usernameInputChange"
                                              v-model="usernameInputTxt"
                                              :minlength="2"
                                              :maxlength="12"
                                              :readonly="!isShowUsernameInputEle"
                                              v-show="isShowUsernameInputEle"></el-input>
                                    <div class="el-icon-edit username-icon" @click="showUsernameInputEle" v-show="!isShowUsernameInputEle"></div>
                                    <div class="el-icon-check username-icon" @click="confirmUserInput" v-show="isShowUsernameInputEle"></div>
                                    <div class="el-icon-close username-icon" @click="cancelUserInput" v-show="isShowUsernameInputEle"></div>
                                </div>
                                <div v-if="hasError" class="username-error">{{errorMsg}}</div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="height:40px">
                            <el-col :span="8" align="right"><icon-text icon-class="el-icon-message" text="邮箱:" :style-object="{height: '36px', lineHeight: '36px'}" /></el-col>
                            <el-col :span="16" align="left">
                                <!-- 下面的这种是特殊的写法，目的是清除 span 之间的空隙 -->
                                <!-- TODO 又遇到一个神级的 BUG，就在 PC Chrome 模拟 phone 的客户端下面的点击去激活链接无法生效，Safari 没问题，手机 chrome 直连没有问题，Hybrid app 也没有问题 -->
                                <span style="height:36px; line-height: 36px">{{email}}</span
                                ><div v-if="!isEmailActivated">
                                    <!-- TODO 为什么浏览器上点击事件无效? -->
                                    <span class="font-gray">邮箱未激活，<my-link @click.native="toActivaiteEmail"><span class="font-black">点击</span></my-link>去激活</span>
                                </div><span v-else style="color:#67C23A; font-size: 12px; margin-left:4px">
                                    <i class="el-icon-circle-check">已激活</i>
                                </span>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" style="height:40px">
                            <el-col :span="8" align="right"><icon-text icon-class="el-icon-coin" text="积分:" :style-object="{height: '36px', lineHeight: '36px'}" /></el-col>
                            <el-col :span="16" align="left"><span style="height:36px; line-height: 36px;">{{points}}</span></el-col>
                        </el-row>
                        <el-row :gutter="20" style="height:40px">
                            <el-col :span="8" align="right"><icon-text icon-class="el-icon-time" text="注册时间:" :style-object="{height: '36px', lineHeight: '36px'}" /></el-col>
                            <el-col :span="16" align="left"><span style="height:36px; line-height: 36px">{{createTs}}</span></el-col>
                        </el-row>
                    </el-card>
                </div>
            </template>
            <template v-else>
                <no-signal
                    ref="noSignal"
                    display-mode="vertical"
                    :retry-handlers="[loadUser_]"
                    :retry-basis="false"
                    :margin-top="35"></no-signal>
            </template>
        </div>
    </my-dialog>
</template>

<script>
    import IconText from "../../commons/IconText";
    import MyDialog from "../../commons/MyDialog";
    import {DateFormat, errorMessage, GlobalLoading} from "../../../utils";
    import { loadUser, changeUsername } from "../../../data/user";
    import { TimeoutError, NetworkError } from '@shangyang/error';
    import { validateUsername } from "../../../validator";

    export default {
        name: "UserInfo",
        components: {MyDialog, IconText},
        data() {
            return{
                loading: false,
                repaintAvatar: false,
                usernameInputTxt: null,
                noSignalVisible: false,
                isShowUsernameInputEle: false,
                hasError: false,
                errorMsg: null,
            }
        },
        computed: {
            username(){
                return this.$store.state.user !== null ? this.$store.state.user.username: null;
            },
            email(){
                return this.$store.state.user !== null ? this.$store.state.user.email: null;
            },
            isEmailActivated(){
                return this.$store.state.user !== null ? this.$store.state.user.is_email_activated : false
            },
            points(){
                return this.$store.state.user !== null ? this.$store.state.user.points : false
            },
            createTs(){
                return this.$store.state.user !== null ? this.$store.state.user.create_ts : false
            }
        },
        created(){
            this.usernameInputTxt = this.username;
        },
        methods: {
            show(){
                this.reset();
                // 延时显示
                setTimeout(()=>{
                    this.$refs.dialog.show();
                }, 300);
                this.loadUser_();  // 为了每次都能够加载最新的 points -> reload user
            },
            reset() {
                this.loading = false;
                this.noSignalVisible = false;
                this.isShowUsernameInputEle = false;
                this.errorMsg = null;
                this.hasError = false;
            },
            showUsernameInputEle(){
                this.isShowUsernameInputEle = true;
                this.$nextTick(()=> {
                    this.$refs.username.focus(); // 必须在 nexttick 中才能生效。
                });
            },
            cancelUserInput(){
                this.isShowUsernameInputEle = false;
                this.hasError = false;
                this.errorMsg = null;
            },
            confirmUserInput(){
                // Validator 验证成功后的回调方法
                function successCallback(isSuccess){
                    (async()=> {
                        try {
                            if (isSuccess) {
                                if (!this.isUsernameUnchange()) { // 表示用户名有改动
                                    console.log(`start to submit the new username ${this.usernameInputTxt}`);
                                    this.usernameInputTxt = this.usernameInputTxt.trim();
                                    await changeUsername(this.usernameInputTxt);
                                    this.$store.commit('changeUsername', this.usernameInputTxt);
                                    this.reset();
                                    // 重绘头像，当且仅当用户名修改成功后才重绘头像。
                                    this.repaintAvatar = true;
                                    setTimeout(() => {
                                        this.repaintAvatar = false;
                                    }, 1000); // 给一个 loading 的假象。
                                }
                            }
                        } catch(error) {
                        } finally {
                            GlobalLoading.stop();
                        }
                    })();
                }

                GlobalLoading.start();
                setTimeout(()=>{
                    this.__validateUsername(successCallback.bind(this));
                }, 300)
            },
            usernameInputChange(){
                console.log(`username input change event: ${this.usernameInputTxt}`);
                this.__validateUsername();
            },
            /**
             * @param {Function} successCallback
             */
            __validateUsername(successCallback=()=>{}){
                validateUsername(null, this.usernameInputTxt, function(error){
                    // 注意，之前本来是判断成功（if/else）后才执行 success callback，但是为了能够实现 GlobalLoading 的逻辑，因此将
                    // 验证结果作为参数传递到 successCallback 中，目的是无论任何情况都要能够回调 successCallback，这样才能实现 GlobalLoading
                    let isSuccess = this.__resolveErrorHanlder(error);
                    successCallback(isSuccess);
                }.bind(this))
            },

            /**
             * @param error, error obj returned from callback.
             * @return {boolean} if validate success, return true else false.
             */
            __resolveErrorHanlder(error){
                if(error){
                    console.log(`error caught: ${error}`)
                    // 特殊情况，如果用户名没有发生变化，不报错。因为现在会实时到后台验证用户名，但是并不会判断是否是自己的用户名导致的重复。
                    // 因此，如果发现用户名并没有发生变化，则是正确的情况。
                    if (this.isUsernameUnchange()) { // this is the special case for no error.
                        console.log('the username is unchanged, so this is not actuall the error happens');
                        this.hasError = false;
                        this.errorMsg = null;
                        return true;
                    }else{
                        this.errorMsg = error.message;
                        this.hasError = true;
                        return false;
                    }
                }else{
                    this.hasError = false;
                    this.errorMsg = null;
                    return true;
                }
            },

            isUsernameUnchange(){
                if (this.usernameInputTxt === this.username){
                    return true;
                }
                return false;
            },
            // reload the user - 为了同步积分（积分是动态变化的）
            async loadUser_(){
                try {
                    let usercode = this.$store.state.user.usercode;
                    this.loading = true;
                    await loadUser.bind(this)(usercode); // will sync the user into $store.state.user.
                    this.noSignalVisible = false; // 显示 no signal comp
                } catch (error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if (error instanceof TimeoutError || error instanceof NetworkError) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                    }
                } finally {
                    this.loading = false;
                }
            },
            toActivaiteEmail(){
                console.log('to activate email');
                this.$refs.dialog.hide();
                this.$parent.$parent.$refs.userActiviateEmail.show();
            },
        }
    }
</script>

<style scoped>

    .username{
        display:inline-flex;
        display:-webkit-inline-flex;
        align-items: center;
        height:36px;
        line-height: 36px;
    }

    .username-error{
        padding-top: 4px;
        color: #F56C6C;
        font-size: 12px;
        /* 下面三个属性是设置 text-overflow 的关键*/
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .username-icon{
        font-weight: 600;
        font-size: 16px;
        margin-left: 14px;
    }

    @media (max-width: 350px) {
        /deep/ .dialog-content-panel {
            height: 270px !important; /* 注意，因为小尺寸屏幕邮箱要占用两行，因此高 30px */
        }
    }

    @media (min-width: 351px){
        /deep/ .dialog-content-panel {
            height: 260px !important;
        }
    }

    /deep/ .el-divider--horizontal{
        height: 0px;
    }

    /* 定制 el-input 用户名输入框 */
    /deep/ .el-input__inner {
        width: 120px; /* 控制输入框的长度 */
        height: 36px !important;
        line-height: 36px !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserInfo.vue